import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-671cf433"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tutorial-course-modal__title" }
const _hoisted_2 = { class: "tutorial-course-modal__text" }

import BaseModal from '@/components/modals/BaseModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import { useInternalization } from '@/composables/useInternalization';


export default /*#__PURE__*/_defineComponent({
  __name: 'TutorialCourseModal',
  props: {
    isOpened: { type: Boolean }
  },
  emits: ['close', 'confirm'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useInternalization();

const emit = __emit;

function close() {
  if (props.isOpened) {
    emit('close');
  }
}

function confirm() {
  emit('confirm');
  close();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-opened": props.isOpened,
    class: "tutorial-course-modal",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)('modals.tutorialCourseTitle')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ol", null, [
          _createElementVNode("li", null, _toDisplayString(_unref(t)('modals.tutorialCourseTextItems[0]')), 1),
          _createElementVNode("li", null, _toDisplayString(_unref(t)('modals.tutorialCourseTextItems[1]')), 1),
          _createElementVNode("li", null, _toDisplayString(_unref(t)('modals.tutorialCourseTextItems[2]')), 1),
          _createElementVNode("li", null, _toDisplayString(_unref(t)('modals.tutorialCourseTextItems[3]')), 1)
        ])
      ]),
      _createVNode(BaseButton, {
        class: "tutorial-course-modal__button",
        onClick: confirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('beginNow')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-opened"]))
}
}

})